export default __webpack_public_path__ + "static/media/playlist-1.7af060bd.jpg";